import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom"; // Import useNavigate


const EditTyre = () => {
  useAuthRedirect();
    const { id } = useParams();
  const navigate = useNavigate(); // Initialize navigate function
  const [branches, setbranches] = useState([]);
  const userName = localStorage.getItem("username"); // Default branch from storage
    // const [selectedBranch, setSelectedBranch] = useState(storedBranch || "");
 const [formData, setFormData] = useState({
  tyre_seriolno : "",
  	tyre_model	: "",
    tyre_make : "",
    tyre_amount	: "",
    tyre_type	 : "",
    tyre_position	: "",
    branch	: "",
    purchased_date: "",
    tyre_enterdate: "",
    tyre_remove	: "No",
    purchased_from: "",
    userid : ""
 
   });

   const canEdit  = hasPermission("Tyre Details", "edit");

   useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/get_branches")
      .then((response) => {
        setbranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);


  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_edit_tyre_api/${id}`
        );
        setFormData({
            tyre_seriolno : response.data.tyre_seriolno,
            tyre_model	: response.data.tyre_model,
          tyre_make : response.data.tyre_make,
          tyre_amount	: response.data.tyre_amount,
          tyre_type	 : response.data.tyre_type,
          tyre_position	: response.data.tyre_position,
          branch	: response.data.branch,
          purchased_date: response.data.purchased_date,
          tyre_enterdate: response.data.tyre_enterdate,
          tyre_remove	: response.data.tyre_remove,
          purchased_from: response.data.purchased_from 
           
        });
      } catch (error) {
        console.error("Error fetching location details:", error);
      }
    };

    fetchLocation();
  }, [id]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

  const payload = {
    tyre_seriolno : formData.tyre_seriolno,
  	tyre_model	: formData.tyre_model,
    tyre_make : formData.tyre_make,
    tyre_amount	: formData.tyre_amount,
    tyre_type	 : formData.tyre_type,
    tyre_position	: formData.tyre_position,
    branch	: formData.branch,
    purchased_date: formData.purchased_date
    ? formData.purchased_date.split("T")[0] // Extract YYYY-MM-DD
    : "",
  tyre_enterdate: formData.tyre_enterdate
    ? formData.tyre_enterdate.split("T")[0]
    : "",
    tyre_remove	: formData.tyre_remove,
    purchased_from: formData.purchased_from,
    userid : userName
  };
  
console.log("Submitting Payload:", payload);

try {
      Swal.fire({
            title: "Submitting...",
            text: "Please wait while we process your request.",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
  const response = await axios.put(
    `https://rfs2.infraconsoft.net.in/api/edit_tyre_api/${id}`,
    formData
  );
  
  Swal.fire({
    title: "Success!",
    text: "Updated successfully.",
    icon: "success",
    width: "500px",
    height: "40vh",
    draggable: true,
}).then(() => {
    navigate("/tyrelisting");
});

} catch (error) {
  console.error("Error submitting form:", error);
  alert("Submission failed. Please try again.");
}
};


  if (!canEdit) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Edit Tyre</h2>
                    <Link to='/tyrelisting'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Serial No :</label>
                <input
                  type="text"
                  name="tyre_seriolno"
                  value={formData.tyre_seriolno}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Entry Date:</label>
                <input
                  type="date"
                  name="tyre_enterdate"
                  value={formData.tyre_enterdate ? formData.tyre_enterdate.split("T")[0] : ""} 
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Model:</label>
                <input
                  type="text"
                  name="tyre_model"
                  value={formData.tyre_model}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Branch:</label>
                <select name="branch"  value={formData.branch}   className="branch-select" onChange={handleChange} >
                    <option value="">-- Select Branch -- </option>
                    {branches.map((item) => (
                        <option key={item.branchMaster_code} value={item.branchMaster_code}>
                        {item.branchMaster_name}
                        </option>
              ))}
            </select>
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Make:</label>
                <input
                  type="text"
                  name="tyre_make"
                  value={formData.tyre_make}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Tyre Type:</label>
                <select name="tyre_type"  value={formData.tyre_type}   className="branch-select"  onChange={handleChange} >
                <option value="">--- Select ---</option>
                <option value="new">New</option>
                <option value="retreated">Retreated</option>
            </select>
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Position:</label>
                <select  name="tyre_position"  value={formData.tyre_position}   className="branch-select" onChange={handleChange} >
                <option value="">--- Select ---</option>
                <option value="Front">Front</option>
                <option value="Rear">Rear</option>
            </select>
              </div>
              <div className="form-group">
                <label>Purchased Date:</label>
                <input
                  type="date"
                  name="purchased_date"
                  value={formData.purchased_date ? formData.purchased_date.split("T")[0] : ""} 
                  onChange={handleChange}
                  required
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Purchased From:</label>
                <input
                  type="text"
                  name="purchased_from"
                  value={formData.purchased_from}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Purchased Amount:</label>
                <input
                  type="text"
                  name="tyre_amount"
                  value={formData.tyre_amount}
                  onChange={handleChange}
                  required
                />
                  </div>
            </div>
           
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default EditTyre;
 